import { initializeApp } from 'firebase/app';
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  updatePassword as firebaseUpdatePassword,
  onAuthStateChanged
} from 'firebase/auth';
import { getDatabase, ref, push, set, remove, onValue } from 'firebase/database';

const config = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_ID
};

// Initialize Firebase
const app = initializeApp(config);
const auth = getAuth(app);
const db = getDatabase(app);

// AUTH FUNCTIONS
const createUser = (email, password) =>
  createUserWithEmailAndPassword(auth, email, password);

const signInUser = (email, password) =>
  signInWithEmailAndPassword(auth, email, password);

const logout = () => signOut(auth);

const resetPassword = email => sendPasswordResetEmail(auth, email);

const updatePassword = password => {
  if (auth.currentUser) {
    return firebaseUpdatePassword(auth.currentUser, password);
  }
  return Promise.reject(new Error('No user logged in'));
};

// DB FUNCTIONS - Returns database references
const user = uid => ref(db, `users/${uid}`);
const users = () => ref(db, 'users');

const list = name => ref(db, `lists/${name}`);
const lists = () => ref(db, 'lists');
const item = (name, id) => ref(db, `lists/${name}/${id}`);

const matches = () => ref(db, 'matches');
const match = (name) => ref(db, `matches/${name}`);

// Export Firebase instance as an object
const Firebase = {
  app,
  auth,
  db,
  createUser,
  signInUser,
  logout,
  resetPassword,
  updatePassword,
  user,
  users,
  list,
  lists,
  item,
  matches,
  match
};

export default Firebase;
export { onAuthStateChanged, ref, push, set, remove, onValue };

